import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'in0005',
    ecrans: ['00-2']
});
